import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer>
      <div className="logo">
        <a href="#">warda</a>
        <h5>the best way to build your site</h5>
      </div>
      <div className="copyrighte">
        <small>&copy; warda. all rights reserved</small>
      </div>
    </footer>
  );
}
